<app-header></app-header>
<header class="slidermain contact-us-page  text-white ">
    <img src="assets/img/conact-us-background.jpg" alt="news" class="w-100">
  <div class="container-fluid">
     <div class="mask-content-v-center text-left">
         <div class="row contact-us">
            
        <div class="col-md-6 cont-form-bg h-100">
           <div class="border-out  my-auto text-center">
              <div class="contact-form">
                <div class="heading text-left">
                  <!-- <h3>Contact Us</h3> -->
                  <h5 class="mb-3">{{ 'contact.con_c1' | translate }} </h5>
                   <hr class="bdr mb-3 mt-1">
                  <!-- <p>To learn more about our process or for a free quote on an upcoming inventory please contact us below</p> -->
              </div>
              <form id="contact" method="POST"  [formGroup]="formGroup" class="form" (ngSubmit)="onSubmit()"> 
                  <div class="row">
                    <div class="col-xs-12 col-md-6 form-group">
                      <i class="fas fa-user icon" aria-hidden="true"></i>
                       <span>
                      <input class="form-control" id="name" formControlName="name" placeholder="{{ 'contact.con_c2' | translate }} " type="text" >
                      </span>
                  </div>
                  <div class="col-xs-12 col-md-6 form-group">
                  <i class="far fa-envelope-open icon"></i>
                       <span>
                      <input class="form-control" id="email" formControlName="email" placeholder="{{ 'contact.con_c3' | translate }} " type="email" >
                      </span>
                  </div>
                  <div class="col-xs-12 col-md-6 form-group">
                      <i class="fas fa-phone icon" aria-hidden="true"></i>
                       <span>
                      <input class="form-control" id="phoneNumber" formControlName="number" placeholder="{{ 'contact.con_c4' | translate }} " >
                    </span>
                  </div>
                  <div class="col-xs-12 col-md-6 form-group">
                    <i class="fas fa-user icon" aria-hidden="true"></i>
                       <span>
                      <input class="form-control" id="subject" formControlName="subject" placeholder="{{ 'contact.con_c5' | translate }} " >
                      </span>
                  </div>
                  <div class="col-xs-12 col-md-12 form-group">
                     <i class="far fa-envelope icon" aria-hidden="true"></i>
                    <span>
                    <textarea class="form-control" id="message" formControlName="message" placeholder="{{ 'contact.con_c6' | translate }} " rows="3"></textarea>
                    </span>
                    </div>
              </div>
              
              <button type="submit" class="btn orderonline box-shadow-none btn-contact float-right"><i class="fas fa-paper-plane" aria-hidden="true"></i> {{ 'contact.con_c7' | translate }}</button>
          </form>

          <p class="text-success" *ngIf="sucessMsg != '' && showLang == 'en' " >{{sucessMsg}}</p>
          <p class="text-success" *ngIf="sucessMsg_ar != '' && showLang == 'ar' " >{{sucessMsg_ar}}</p>

          <p class="text-danger" *ngIf="errorMsg != '' && showLang == 'en' " >{{errorMsg}}</p>
          <p class="text-danger" *ngIf="errorMsg_ar != '' && showLang == 'ar' " >{{errorMsg_ar}}</p>
      </div>
  </div>
</div>

<div class="col-md-6 mt-3 mt-md-0 contbg text-left">
               <h3>{{ 'contact.con_c16' | translate }}</h3>
               <hr class="bdr">
               <h4>{{ 'contact.con_c9' | translate }}</h4>
               <div class="contacts-item">
                <div class="icon">
                    <img src="assets/img/address.png" alt="Address">
                </div>
                <div class="content">
                    <p class="address">{{ 'contact.con_c10' | translate }}</p>
                    <p class="sub-title"><i class="fas fa-phone-alt"></i> ‎‎+97126333996</p>
                </div>
                <hr>
            </div>

            <div class="contacts-item">
               
                <div class="content">
                    <p class="address"><a target="_blank" href="https://goo.gl/maps/XLVhPeKR9ayU6PhC8"> {{ 'contact.con_c11' | translate }}</a>
                                                      
                                        </p>
                                        <a class="map-link" target="_blank" href="https://goo.gl/maps/XLVhPeKR9ayU6PhC8">  {{ 'contact.con_c12' | translate }} </a>
                    <p class="sub-title"> {{ 'contact.con_c13' | translate }}: 02-6260607 </p>
                </div>
                <hr>
            </div>

            <!-- <div class="contacts-item mb-3">
               
                <div class="content">
                    <p class="address"><a target="_blank" href="https://goo.gl/maps/TXX7cSoRUa3CrVA67">   {{ 'contact.con_c14' | translate }}</a></p>
                    <a class="map-link" target="_blank" href="https://goo.gl/maps/TXX7cSoRUa3CrVA67">  {{ 'contact.con_c12' | translate }} </a>
                    <p class="sub-title"> {{ 'contact.con_c13' | translate }}: 02-6339094 or 02-6339095 </p>
                </div>
                <hr>
            </div> -->

            <div class="contacts-item mb-3">
               
                <div class="content">
                    <p class="address"><a target="_blank" href="https://goo.gl/maps/qnRWgF35g6NwYGsR9"> {{ 'contact.con_c15' | translate }}</a></p>
                    <a class="map-link" target="_blank" href="https://goo.gl/maps/qnRWgF35g6NwYGsR9">  {{ 'contact.con_c12' | translate }}</a>
                    <p class="sub-title">{{ 'contact.con_c13' | translate }}: 02-6333996</p>
                </div>
         
            </div>

        </div>
</div>

</div>
</div>
</header>